import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class QuillEditorService {
  public readonly modules = {
    toolbar: {
      container: [['bold', 'italic', 'underline', { list: 'ordered' }, { list: 'bullet' }, 'link', 'blockquote']],
      handlers: {
        time: () => console.log('Not set Handler')
      }
    },
    magicUrl: true
  };
}
